import { render, staticRenderFns } from "./ThemeFileIcon.view.vue?vue&type=template&id=034ac4e6&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('034ac4e6')) {
      api.createRecord('034ac4e6', component.options)
    } else {
      api.reload('034ac4e6', component.options)
    }
    module.hot.accept("./ThemeFileIcon.view.vue?vue&type=template&id=034ac4e6&", function () {
      api.rerender('034ac4e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/home/ThemeFileIcon.view.vue"
export default component.exports